<template>
  <div :class="`pinwall__list${mode && mode !== 'search' ? '__' + mode : ''}`">
    <ul>
      <li
        v-for="post in posts"
        :id="post.id"
        :key="post.id"
        :style="post.style"
      >
        <Post
          @delete="deletePost"
          @fullscreen="fullscreen"
          @editPost="editPost"
          @openComments="openComments"
          @approvePost="approvePost"
          @filePreview="filePreview"
          :post="post"
          :mode="mode"
          :view="'list'"
          :withComments="withComments"
          @ended="ended"
        ></Post>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Post from "./Post";

export default {
  name: "list",
  components: {
    Post
  },
  props: {
    posts: {
      type: Array
    },
    mode: {
      type: String,
      default: null
    },
    withComments: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapMutations(["setPlayingPost", "setUserClickedOnMedia"]),
    deletePost(item) {
      this.$emit("deletePost", item);
    },
    editPost(item) {
      this.$emit("editPost", item);
    },
    fullscreen(item) {
      this.$emit("fullscreen", item);
    },
    openComments(item) {
      this.$emit("openComments", item);
    },
    approvePost(item) {
      this.$emit("approvePost", item);
    },
    filePreview(item) {
      this.$emit("filePreview", item);
    },
    ended() {
      this.$emit("ended");
    }
  },
  created() {
    this.setPlayingPost(null);
    this.setUserClickedOnMedia(false);
  }
};
</script>
